var mp = mp || {};

// Form validation
//----------------------------------------------------------
mp.formContact = function() {
    var $form = $('#form-contact');
        $submitBtn = $form.find('button.btn');

    if (!$form.length) {
        return;
    }

    $form.validate({
        rules: {
            first_name: {
                required: true,
                minlength: 2
            },
            last_name: {
                required: true,
                minlength: 2
            },
            email: {
                required: true,
                email: true
            },
            message: {
                required: true,
                minlength: 10
            },
        },
        errorPlacement: function(error, element) {

        },

        invalidHandler: function(event, validator) {
            // $submitBtn.toggleClass('disabled');
        },

        submitHandler: function(form) {
            $submitBtn.attr('disabled','disabled');

            var $formData = new FormData(form);
            var $sitekey = $form.find('input[name=recaptcha_site_key]').val();

            grecaptcha.ready(function() {
                grecaptcha.execute($sitekey).then(function(token) {
                    $formData.append('token', token);

                    $.ajax({
                        url: form.action,
                        type: form.method,
                        data: $formData,
                        cache: false,
                        contentType: false,
                        processData: false,
                        success: function(response) {
                            $submitBtn.removeAttr('disabled');

                            if (response.status=="success") {
                                form.reset();
                                $('select').selectric('refresh');
                                
                                alert(response.message);
                            } else {
                                alert(response.message);
                            }
                        }            
                    });
                });
            });
        }

    });
};



// Form validation
//----------------------------------------------------------
mp.formNewsletter = function() {
    var $form = $('#form-newsletter');
        $submitBtn = $form.find('button.btn');
        $submitBtn = $form.find('button.btn');
        $success = $form.next('.success');

    if (!$form.length) {
        return;
    }

    $form.validate({
        rules: {
            "fields[email]": {
                required: true,
                email: true
            },
        },
        errorPlacement: function(error, element) {

        },

        invalidHandler: function(event, validator) {
            // $submitBtn.toggleClass('disabled');
        },

        submitHandler: function(form) {
            $submitBtn.attr('disabled','disabled');

            var $formData = new FormData(form);

            $.ajax({
                url: form.action,
                type: form.method,
                data: $formData,
                cache: false,
                contentType: false,
                processData: false,
                success: function(response) {
                    $submitBtn.removeAttr('disabled');

                    if (response.success==true) {
                        form.remove();
                        $success.removeClass('hide');
                    }
                }            
            });
        }

    });
};



$(document).ready(function (){
    mp.formContact();
    mp.formNewsletter();
});